import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import betoverviewComponent from './betoverview.component';

// Components for overview
import overviewComponent from './component/overview/overview.component';
import overviewSearchFormComponent from './component/overview/component/searchform.component';
import overviewSummaryTableComponent from './component/overview/component/summarytable.component';

// Components for bets
import betsComponent from './component/bets/bets.component';
import filterDetailsComponent from './component/bets/component/filterdetails.component';
import betListingComponent from './component/bets/component/listing.component';

let betoverviewModule = angular.module('betoverview', [
  uiRouter
])
.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
  .state('betoverview', {
    parent: 'standardLayout',
    redirectTo: 'betoverview.overview',
    url: '/betoverview',
    component: 'betoverview',
  })
  .state('betoverview.overview', {
    url: '',
    component: 'betOverviewOverview',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    }
  })
  .state('betoverview.bets', {
    url: '/bets?from&to&league&betType&betTypeText&leagueText',
    component: 'bets',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    },
    reloadOnSearch: false
  })
  ;
})
.component('betoverview', betoverviewComponent)
// Overview Components
.component('betOverviewOverview', overviewComponent)
.component('overviewSearchForm', overviewSearchFormComponent)
.component('overviewSummaryTable', overviewSummaryTableComponent)
// Bets Componnents
.component('bets', betsComponent)
.component('filterDetails', filterDetailsComponent)
.component('betListing', betListingComponent)
.name;

export default betoverviewModule;


// WEBPACK FOOTER //
// ./client/app/pages/customer/betoverview/betoverview.js